export const TOASTIFY_NEW_COMMAND = "TOASTIFY_NEW_COMMAND";
